import { Client } from '@/utilities/api/Client';

export class UtilityApi {
  static getIsUrlReachable (
    url: string,
  ): Promise<boolean> {
    return Client(`utility/is-url-reachable?url=${encodeURIComponent(url)}`);
  }
}
